import { render, staticRenderFns } from "./UserWorkSpaceView.vue?vue&type=template&id=485bc96e&scoped=true&"
import script from "./UserWorkSpaceView.vue?vue&type=script&lang=js&"
export * from "./UserWorkSpaceView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "485bc96e",
  null
  
)

export default component.exports